import { forwardRef, createElement } from 'react';

function IconWarning(props, svgRef) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), createElement("path", {
    d: "M9.527 17.197c.157-.827.938-1.344 1.771-1.177a1.515 1.515 0 011.213 1.772c-.157.826-.939 1.343-1.771 1.177a1.515 1.515 0 01-1.213-1.772zm2.265-11.05c.164-.863.784-1.276 1.607-1.112.815.163 1.23.782 1.066 1.646l-.038.183-.025.097-1.368 6.473c-.179.793-.67 1.182-1.43 1.03-.712-.142-1.032-.634-.96-1.356l.02-.147 1.1-6.628.028-.185z",
    fill: "currentColor"
  }));
}

var Warning = /*#__PURE__*/forwardRef(IconWarning);

export default Warning;
//# sourceMappingURL=Warning.js.map
